export default "__VITE_ASSET__50073f7c__"